import { ErrorHandler, Injectable } from '@angular/core';
import { recoverFromLazyChunkFailure } from './lazy-chunk-recovery';

@Injectable()
export class LazyChunkRecoveryErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (!recoverFromLazyChunkFailure(error)) {
      console.error(error);
    }
  }
}
